// api/axios.js
import axios, { AxiosRequestConfig } from "axios";

const ICMAxios = axios.create({
  baseURL: process.env.REACT_APP_API_KEY,
  timeout: 10000 * 5,
  headers: {
    "Content-Type": "application/json",
  },
});

ICMAxios.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("token");
    const clientId = Number(localStorage.getItem("clientId"));
    const guid = localStorage.getItem("guid");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    if (clientId) {
      config.headers["ClientId"] = clientId.toString();
    }
    if (guid) {
      config.headers["X-GUID"] = guid;
    }
    // Set Api-Version dynamically based on URL
    const versionMatch = config.url?.match(/v(\d+)/i);
    if (versionMatch && versionMatch[1]) {
      config.headers["Api-Version"] = versionMatch[1];
    }

    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ICMAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // handle the response error
    if (error.response.status === 401) {
      // handle unauthorized access, you may want to redirect to login page
      console.error("Unauthorized access");
    } else if (error.response.status === 429) {
      console.error("Too many requests. Please try again later!");
    } else {
      // You can even send the error information to a logging service.
      console.error("Error Message:", error.message);
    }

    return Promise.reject(error);
  }
);

export default ICMAxios;
